export default __webpack_public_path__ + "static/media/finalpractice.e857f17b.png";